/* eslint-disable max-len */
const GridIcon = props => (
  <svg
    className={props?.className || "h-6 w-6"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <title>{"Modules"}</title>
    <rect x="4" y="4" width="6" height="6" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="4" width="6" height="6" stroke="currentColor" strokeWidth="2" />
    <rect x="4" y="14" width="6" height="6" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="14" width="6" height="6" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default GridIcon;
